import { useState } from "react";
import { useAppDispatch } from "../../../../../hooks/reduxHooks";
import { generateDesignData } from "../../../../store/slices/viewSlice";

const DesignNotes = () => {
  const dispatch = useAppDispatch();
  const [data, setData] = useState(null as any);
  const downloadData = async (key: string, item: any) => {
    const { image_url, svg, json } = item;

    // Download image
    const imageResponse = await fetch(image_url);
    const imageData = await imageResponse.blob();
    const imageObjectURL = URL.createObjectURL(imageData);

    // Download SVG
    const svgBlob = new Blob([svg], { type: "image/svg+xml" });
    const svgObjectURL = URL.createObjectURL(svgBlob);

    // Download JSON
    delete item.svg;
    delete item.image_url;
    const jsonBlob = new Blob([JSON.stringify(item)], {
      type: "application/json",
    });
    const jsonObjectURL = URL.createObjectURL(jsonBlob);

    // Create anchor element for downloading
    const downloadLink = document.createElement("a");
    downloadLink.href = imageObjectURL; // You can change this to svgObjectURL or jsonObjectURL
    downloadLink.download = `downloaded_file_${key}`; // Set desired file name with the key
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    // Clean up object URLs
    URL.revokeObjectURL(imageObjectURL);
    // Repeat for svgObjectURL and jsonObjectURL

    const downloadLink2 = document.createElement("a");
    downloadLink2.href = svgObjectURL; // You can change this to svgObjectURL or jsonObjectURL
    downloadLink2.download = `downloaded_file_${key}`; // Set desired file name with the key
    document.body.appendChild(downloadLink2);
    downloadLink2.click();
    document.body.removeChild(downloadLink2);

    // Clean up object URLs
    URL.revokeObjectURL(svgObjectURL);

    const downloadLink3 = document.createElement("a");
    downloadLink3.href = jsonObjectURL; // You can change this to svgObjectURL or jsonObjectURL
    downloadLink3.download = `downloaded_file_${key}`; // Set desired file name with the key
    document.body.appendChild(downloadLink3);
    downloadLink3.click();
    document.body.removeChild(downloadLink3);

    // Clean up object URLs
    URL.revokeObjectURL(jsonObjectURL);
  };

  function removeLineObjectFromAll(jsonData: any) {
    for (const key in jsonData) {
      if (
        jsonData.hasOwnProperty(key) &&
        jsonData[key].json &&
        jsonData[key].json.objects
      ) {
        // Filter out objects with type "line"
        jsonData[key].json.objects = jsonData[key].json.objects.filter(
          (obj: any) => obj.type !== "line"
        );
      }
    }

    // Return the modified JSON
    return jsonData;
  }

  return (
    <>
      <div className="font-bold text-2xl tracking-wide">
        Add Notes About your Design
      </div>
      <div className="text-[#8D9095] border-b border-solid border-lightgrey pb-3 mb-3">
        Leave a note for our design specialist. We review every note after you
        place your order.
      </div>
      <div className="my-4 overflow-hidden">
        <textarea
          className="border border-solid border-lightgrey resize-none w-full h-[100px] p-2 rounded-sm"
          name="designNotes"
          id="designNotes"
          placeholder="Add your Notes here..."
        ></textarea>
        <button className="float-right px-7 py-2 my-2 bg-primaryred rounded-md font-bold text-white">
          Save Note
        </button>
      </div>
      <div className="my-4">
        <div className="font-bold">Use notes to request things such as:</div>
        <ul>
          <li>- Special artwork instructions</li>
          <li>- Pantone color matching codes (PMS)</li>
          <li>- Art rotations and touch-ups</li>
          <li>- Sleeve printing</li>
        </ul>
      </div>
      <button
        onClick={() => {
          dispatch(generateDesignData({}))
            .unwrap()
            .then((data: any) => {
              const modifiedData = removeLineObjectFromAll(data);
              setData(modifiedData);

              console.log("data_____"  ,data , modifiedData);
            });
        }}
      >
        <button className="bg-[#DBF2FA] cursor-pointer text-[#1164A9] font-medium me-2 px-3 py-1.5 mb-4 rounded-full">
          Generate JSON
        </button>
        <hr className="mb-5" />
        {data
          ? Object.entries(data).map(([key, item]: any) => (
              <button
                className="bg-transparent cursor-pointer text-[#222222] font-medium me-2 px-3 py-1.5 mb-4 rounded-full"
                key={key}
                onClick={() => downloadData(key, item)}
              >
                Download Item {item.name}
              </button>
            ))
          : ""}
      </button>
    </>
  );
};

export default DesignNotes;
